<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .title -->
            <b-col lg="12">
              <b-form-group
                id="input-group-1"
                :label="$t('library.content_address')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="title"
                  vid="title"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.title"
                    type="name"
                    :placeholder="$t('library.content_address')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="name-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .Description -->
            <b-col lg="12">
              <b-form-group
                id="input-group-7"
                :label="$t('library.content_description')"
                label-for="input-7"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Description"
                  vid="Description"
                  rules="required"
                >
                  <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                    id="input-7"
                    v-model="newItem.Description"
                    :placeholder="$t('library.content_description')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </ckeditor>
                  <small class="name-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .file_setting -->
            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('library.choose_content_type')"
                label-for="input-4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="file_setting"
                  vid="file_setting"
                  rules="required"
                >
                  <b-form-select
                    v-model="newItem.file_setting_id"
                    :options="file_settings"
                    text-field="type"
                    value-field="id"
                    
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('library.choose_content_type')"
                  />
                  <small class="name-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .licence -->
            <b-col lg="6">
              <b-form-group
                id="input-group-5"
                :label="$t('library.choose_type_of_content_license')"
                label-for="input-5"
              >
                <validation-provider
                  #default="{ errors }"
                  name="licence"
                  vid="licence"
                  rules="required"
                >
                  <b-form-select
                    v-model="newItem.licence_id"
                    :options="licences"
                    
                    value-field="id"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('library.choose_type_of_content_license')"
                  />
                  <small class="name-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .category -->
            <b-col lg="6">
              <b-form-group
                id="input-group-6"
                :label="$t('library.tags')"
                label-for="input-6"
              >
                
                  <v-select
                    dir="rtl"
                    multiple
                    taggable
                    push-tags
                    :options="tags"
                    :placeholder="$t('library.tags')"
                    v-model="newItem.tags"
                    :reduce="(item) => item.id"
                    label="name"
                  />

                 
              </b-form-group>
            </b-col>
            <!-- .category -->
            <b-col lg="6">
              <b-form-group
                id="input-group-6"
                :label="$t('library.category')"
                label-for="input-6"
              >
               
                  <tree
                    :data="treeData"
                    :options="treeOptions"
                    @node:selected="onNodeSelected"
                  />

                
              </b-form-group>
            </b-col>
            <!-- .access -->
            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('library.choose_show_permission')"
                label-for="input-2"
              >
                
                  <div class="demo-inline-spacing">
                    <b-form-radio
                      v-model="newItem.access"
                      value="1"
                      class="custom-control-primary"
                    >
                      {{ $t("library.public_access") }}
                    </b-form-radio>
                    <b-form-radio
                      v-model="newItem.access"
                      value="2"
                      class="custom-control-primary"
                    >
                      {{ $t("library.student_access") }}
                    </b-form-radio>
                    <b-form-radio
                      v-model="newItem.access"
                      value="3"
                      class="custom-control-primary"
                    >
                      {{ $t("library.staff_access") }}
                    </b-form-radio>
                  </div>
                  
              </b-form-group>
            </b-col>

            <!-- .file_url -->
            <b-col lg="12">
              <b-form-group
                id="input-group-8"
                :label="$t('library.choose_file')"
                label-for="input-8"
              >
                <validation-provider
                  #default="{ errors }"
                  name="file_url"
                  vid="file_url"
                  rules="required"
                >
                  <b-form-file
                    v-model="newItem.file"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  />
                  <small class="name-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
               
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success"  >
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/LibraryController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import File_settingsController from "@/Controllers/File_settingsController";
import LicensesController from "@/Controllers/LicensesController";
import CategoriesController from "@/Controllers/CategoriesController";
import LiquorTree from "liquor-tree";
import TagsController from "@/Controllers/TagsController";
import vSelect from "vue-select";

export default {
  name: "LibraryForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    vSelect,
    tree: LiquorTree,
  },
  data() {
    return {
      file: {},
      
      file_settings: [],
      licences: [],
      categories: [],
      treeData: this.getData(),
      treeOptions: {},
      tags: [],
    };
  },
  async created() {
    this.file_settings = await new File_settingsController().GetAll();
    console.log(this.file_settings );
     this.licences = await new LicensesController().GetAll();
    this.tags = await new TagsController().GetAll();
  },
  methods: {
    async getData() {
      return await new CategoriesController().GetAllTree();
    },
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    onNodeSelected(node) {
      this.newItem.category_id = node.id;
    },
  },
};
</script>

